import { Fragment } from 'react';
import useEditWarningModal from 'documents-ui/utils/useEditWarningModal';
import * as EditWarningModalTypes from 'documents-ui/constants/EditWarningModalTypes';
import { Flex } from 'foundations-components/components/Flex';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonWithEditWarning = ({
  showEditWarnings,
  onClick,
  owner,
  children,
  disabled,
  testId,
  icon
}) => {
  const {
    editWarningModal,
    onChangeWithEditWarnings
  } = useEditWarningModal({
    type: EditWarningModalTypes.REUPLOAD,
    showEditWarnings,
    onConfirm: onClick,
    owner
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [editWarningModal, /*#__PURE__*/_jsx(SelectableBox, {
      type: "default",
      selected: false,
      onClick: onChangeWithEditWarnings,
      flush: true,
      block: true,
      disabled: disabled,
      "data-test-id": testId,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: icon,
          size: "600",
          borderInlineEndStyle: "solid",
          borderInlineEndColor: "border-interactive-default",
          borderInlineEndWidth: "100",
          padding: "400"
        }), /*#__PURE__*/_jsx(View, {
          padding: "300",
          as: "span",
          children: children
        })]
      })
    })]
  });
};
export default ButtonWithEditWarning;